export interface SystemSettings {
  date: string;
  time: string;
}

export interface LengthUnit {
  isMeter: boolean;
}
export interface CoordinateSettings {
  latitude: number,
  longitude: number
}

export interface OrphanNotifications {
  emails: string[];
  mobileInfo: {
    mobileCarrierId: number;
    phoneNumber: string;
  }[];
  sendNotification: boolean;
  showToast: boolean;
}

export interface SystemCheckInGraceConfiguration {
  gracePercent: number,
  gracePeriod: number,
}

export interface ServerSettings {
  serverId: string;
  receiverNumber: number;
  ipLinkPort: number;
  ipSubscriberPort: number;
  defaultBUID: number;
  orphanBUPassword?: string;
  orphanBUPasswordRepeat?: string;
}

export interface NetworkSettings {
  dns: string[];
  ip: string;
  netmask: string;
  gateway: string;
}

export interface TcpSettings {
  isIpLinksStop: boolean;
  isIpSubscribersStop: boolean;
}

export interface WebRelay {
  webRelayIp: string | null;
  ringDuration: number;
  pauseDuration: number;
  firstPulseHour: string;
  secondPulseHour: string;
}

export interface HydrantRadiusSettings {
  isEnabled: boolean;
  radius: number;
}

export interface AutoAckSettings {
  eventCode: number,
  eventType: string,
  id: number,
  zoneCode: number | string,
  areaCode?: string,
  code?: string;
}

export interface AutoAckEventTypes {
  autoAckTypePEvents: boolean;
  autoAckTypeREvents: boolean;
}
export interface TechOptionsSettings {
  [key: string]: TechOption[];
}
export interface TechOption {
  category: string;
  description: string;
  enabled: boolean;
  masterKey: string;
}

export interface TechOptionCategoryConfig {
  value: string;
  label: string;
}

export type SubToolsSettingsDataConfiguration = {
  modeSettings: boolean;
  modelRevision: boolean;
  timingSettings: boolean;
  ttl: boolean;
  zoneConfiguration: boolean;
};

export type SubToolsSettingsExecution = {
  lastExecution: string; // date time???
  nextExecution: string; // date time???
};

export type SubToolsSettingsUnits = {
  servicedSubs: number;
  scannedSubs: number;
};

export enum SubToolsSettingsFirstDataRunInterval {
  'EVERY_24_HOURS' = 'EVERY_24_HOURS',
  'EVERY_48_HOURS' = 'EVERY_48_HOURS',
  'NEVER' = 'NEVER',
}
export enum SubToolsSettingsRefreshDataCriteria {
  'OLDER_THAN_30_DAYS' = 'OLDER_THAN_30_DAYS',
  'OLDER_THAN_60_DAYS' = 'OLDER_THAN_60_DAYS',
  'NEVER' = 'NEVER',
}

export type SubToolsSettings = {
  firstData: SubToolsSettingsDataConfiguration &
    SubToolsSettingsExecution &
    SubToolsSettingsUnits & {
      runInterval: SubToolsSettingsFirstDataRunInterval;
    };
  refreshData: SubToolsSettingsDataConfiguration &
    SubToolsSettingsExecution &
    SubToolsSettingsUnits & {
      criteria: SubToolsSettingsRefreshDataCriteria;
    };
  subToolsTimeFrom: string;
  subToolsTimeTo: string;
};

export type SubToolsExecuteSection = 'first-data' | 'refresh-data';

export type Antenna = {
  id: number;
  name: string;
};

export type FCCData = {
  callSign: string;
  expiry: string;
  frequency: number;
  granted: string;
  latitude: number;
  license: string;
  longitude: number;
};

export type InstancesInfo = {
  ipAddress: string;
  instanceNumber: number;
  healthStatus: string;
  externalIp: string;
};

export type PortConfiguration = {
  isHttps: boolean;
};

export type SSLRequest = {
  country: string;
  state: string;
  city: string;
  company: string;
  department: string;
  email: string;
  commonName: string;
};

export type DatabaseDump = {
  fileName: string;
  timestamp: number;
}

export type DatabaseDumpReplicationSettings = {
  isActive: boolean;
  isFull: boolean;
};

export type DatabaseDumpHistory = {
  description: string;
  destinationIp: string;
  destinationNumber: number;
  endTime: number;
  sourceIp: string;
  sourceNumber: number;
  startTime: number;
  status: string;
};

export type ScheduledDBDumpStatus = 'ON' | 'OFF';

export type MFAAuthenticationSettings = {
  isMfaActive: boolean;
};

export interface ULWaringSettings {
  showULWarning: boolean;
}

export type HTTPIntegration = {
  apiKey: string;
  deviceId: string;
  ipAddress: string;
  isEnabled: boolean;
  portNumber: number;
};

export type SMTPSettings = {
  useDefaultConfig: boolean;
  hostname?: string;
  mailFromAddress?: string;
  password?: string;
  port?: number;
  username?: string;
};

export type NotificationsTemplate = {
  buName: boolean;
  customerName: boolean;
  customerPhone: boolean;
  dealersCount: boolean;
  unitAddress: boolean;
};

export type AssetsImage = {
  assetName: string;
  createdAt: string;
  id: number,
  image?: string;
  lastUpdated: string;
  notes: string;
  size?: number;
};

export type AssociateImages = {
	buId: number;
	unitId: number;
	images: Partial<AssetsImage>[];
};

export type INCCLogFiles = {
  fileName: string;
  timestamp: number | null;
  fileSize?: number;
};

export type SMTPOutboundEmailTest = {
  emailAddress: string;
  mobileCarrierId: number;
  phoneNumber: string;
};

export type SMTPEmailTestConnection = {
  error?: string;
  isConnected: boolean;
};
